/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Button, Modal } from '@mairistem/composants';

import RecenseListeContainer from '@/components/Recense/Liste/RecenseListeContainer';

interface RecenseModalProps {
  open: boolean;
  title?: string;
  doubleNationalite?: boolean;
  typeRecensement?:
    | 'all'
    | 'recenses'
    | 'recenses-regularises'
    | 'non-recenses'
    | 'recenses-recenses-regularises';
  periode?: string;
  onClose: () => void;
}

const RecenseModal = (props: RecenseModalProps) => {
  const {
    open,
    title = 'Liste des recensés',
    doubleNationalite,
    typeRecensement,
    periode,
    onClose,
  } = props;

  return (
    <Modal open={open} onClose={onClose} size="large" closeIcon>
      <Modal.Header content={title} />
      {/* @ts-expect-error Type error */}
      <Modal.Content style={{ height: '700px' }}>
        <div style={{ height: '560px' }}>
          <RecenseListeContainer
            doubleNationalite={doubleNationalite}
            typeRecensement={typeRecensement}
            periode={periode}
          />
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button
          basic
          size="small"
          icon="close"
          content="Fermer"
          onClick={onClose}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default RecenseModal;
